export default __webpack_public_path__ + "static/media/bgContactFooter.be4417a2.png";